export enum AssetType {
    Workstring = 1,
    Reel = 2,
    Injector = 3,
    Gooseneck = 4,
    Bop = 5,
    BopQuad = 6,
    BopDual = 7
}